import * as _ from 'lodash';
import { ADD_CATEGORIES, CATEGORIES_ADD_CATEGORIES_FOR_USER, SET_CATEGORIES_LOADING } from '@Actions/categoriesActions';
export const initialState = {
    activeCategories: [],
    disabledCategories: [],
    allCategories: [],
    categoriesByUser: {},
    loading: false
};
function filterWithSubcategories(categories, filterCondition) {
    const filteredArray = [];
    for (const category of categories) {
        if (filterCondition(category)) {
            const copyCategory = Object.assign({}, category);
            const filteredSubCategoryArray = [];
            if (category.subcategories) {
                for (const subcategory of category.subcategories) {
                    if (filterCondition(subcategory)) {
                        filteredSubCategoryArray.push(subcategory);
                    }
                }
                copyCategory.subcategories = filteredSubCategoryArray;
            }
            filteredArray.push(copyCategory);
        }
    }
    return filteredArray;
}
export function categoriesReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_CATEGORIES:
            return _.assign({}, state, {
                activeCategories: filterWithSubcategories(action.categories, (category) => category.enabled),
                disabledCategories: action.categories.filter((category) => !category.enabled),
                allCategories: action.categories
            });
        case SET_CATEGORIES_LOADING:
            return Object.assign(Object.assign({}, state), { loading: action.payload });
        case CATEGORIES_ADD_CATEGORIES_FOR_USER:
            return Object.assign(Object.assign({}, state), { categoriesByUser: Object.assign(Object.assign({}, state.categoriesByUser), { [action.payload.userId]: action.payload.categories }) });
        default:
            return state;
    }
}
